var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgServiceEstate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 125,
    viewBox: "0 0 206 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.0007 26.4166L115.612 0L138.359 25.6828V123.983H98.0007V26.4166Z",
    fill: "#C8DFF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.611 0H182.565L205.867 25.6828H138.358L115.611 0Z",
    fill: "#3A7EFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 98,
    transform: "matrix(-1 0 0 1 206 26)",
    fill: "#DAECFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 17,
    transform: "matrix(-1 0 0 1 177 43)",
    fill: "#1F2E3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 17,
    transform: "matrix(-1 0 0 1 177 64)",
    fill: "#1F2E3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.866 70.9205L90.2554 44.5039L67.5078 70.1867V124.487H107.866V70.9205Z",
    fill: "#A9CAE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2566 44.5039H23.3024L0 70.1867H67.509L90.2566 44.5039Z",
    fill: "#3A7EFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 70.1875,
    width: 67.509,
    height: 54.3007,
    fill: "#CCE4F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6895,
    y: 87.6094,
    width: 15.3663,
    height: 15.3663,
    fill: "#1F2E3D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5469,
    y: 93.752,
    width: 15.3663,
    height: 30.7326,
    fill: "#1F2E3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgServiceEstate);
export default __webpack_public_path__ + "static/media/ImgServiceEstate.7d8270d2ad9b774700fd31f9f9567525.svg";
export { ForwardRef as ReactComponent };